import type { ReactNode } from 'react';
import React, { Fragment } from 'react';
import { usePaginate } from 'Src/hooks/use-paginate/usePaginate';
import { t } from 'Src/i18n';
import { Button } from 'Components/frameworks/button/Button';
import { ProgressBar } from 'Components/frameworks/progress-bar/ProgressBar';
type Props = {
  iterationNumber?: number;
  children: ReadonlyArray<Node>;
  forceInitialShowingItemsNumber?: number;
  onClick?: () => void;
  seeMoreLabel: string;
  setForceInitialShowingItemsNumber?: (arg0: number) => void;
};
export const Paginate = ({
  children,
  forceInitialShowingItemsNumber,
  iterationNumber,
  onClick,
  seeMoreLabel,
  setForceInitialShowingItemsNumber,
}: Props) => {
  const { paginatedItems, itemsShowing, totalOfItems, seeMoreAction, shouldShowSeeMore } =
    usePaginate({
      forceInitialShowingItemsNumber,
      items: children,
      iterationNumber,
    });

  const onClickHandler = () => {
    seeMoreAction();
    onClick?.();
    setForceInitialShowingItemsNumber?.(forceInitialShowingItemsNumber + iterationNumber);
  };

  return (
    <Fragment>
      {paginatedItems}
      {shouldShowSeeMore && (
        <div className="mt-20 text-center" data-testid="paginated-seeMoreBlock">
          <p className="mb-10 text-14 text-black">
            {t('booking.accommodation.moreRooms.numberOfProposalsSeen', {
              number: itemsShowing,
              totalProposalsNumber: totalOfItems,
            })}
          </p>
          <ProgressBar
            className="mx-auto mb-20 w-180 bg-lightSand"
            min={0}
            max={100}
            value={(itemsShowing / totalOfItems) * 100}
          />
          <Button onClick={onClickHandler} size="medium">
            {seeMoreLabel}
          </Button>
        </div>
      )}
    </Fragment>
  );
};
